import {
  HTTP_INTERCEPTORS,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { UtilService } from '../services/util.service';

@Injectable()
export class CheckRequestInterceptor implements HttpInterceptor {
  intercept(
    httpRequest: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    if (httpRequest.body && !httpRequest.url.includes('/OnlineSurvey'))
      httpRequest = httpRequest.clone({
        body: UtilService.removeEmpty(httpRequest?.body),
      });
    return next
      .handle(httpRequest)
      .pipe(catchError((err) => throwError(() => err)));
  }
}

export const HttpCheckRequestInterceptorProviders = [
  {
    provide: HTTP_INTERCEPTORS,
    useClass: CheckRequestInterceptor,
    multi: true,
  },
];
